import { useState, useEffect, useRef } from "react";
import { getCase, sendResponse, sendSurvey } from "../../utilities/cases-service";
import { getUser } from "../../utilities/users-service";
import Loader from "../../components/Loader/Loader";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaLinkedin, FaLink } from "react-icons/fa";
import { HiDownload } from "react-icons/hi";
import { IoMailSharp } from "react-icons/io5";
import { MdCheck, MdArrowUpward, MdArrowDownward, MdDragIndicator } from "react-icons/md";


import { addCompletedCaseId } from '../../utilities/users-api'; // adjust relative path if needed


import "./CasesShowPage.css";
import OpenAI from "./OpenAI";

// Supported phases (six)
const ALLOWED_PHASES = [
  "submissionOne",
  "submissionTwo",
  "submissionThree",
  "submissionFour",
  "submissionFive",
  "submissionSix",
];

// Phases with chat enabled
const CHAT_ENABLED = new Set(["submissionTwo", "submissionFour", "submissionSix"]);

// Next phase progression
const NEXT_PHASE = {
  submissionOne: "submissionTwo",
  submissionTwo: "submissionThree",
  submissionThree: "submissionFour",
  submissionFour: "submissionFive",
  submissionFive: "submissionSix",
  submissionSix: null, // after 6 we show survey
};



export default function CasesShowPage({ user, setUser }) {
  // Optional during dev; keep disabled in prod
  function clearAllCache() {
    // localStorage.clear();
  }
  // clearAllCache();

  // as of 10.1.25, keep thing above this disabled!!!  otherwise it will log out the user when you hit refresh, but then you'll still be able to do thte case


// TRY scroll 10.5

        function scrollCaseLeftOncePerPhase({ caseId, phase, tag = "phase", smooth = true }) {
          const key = `case-${caseId}-${phase}-${tag}-scrolledOnce`; // <— tag makes keys unique
          if (localStorage.getItem(key)) return;
          const el = document.querySelector(".case-left");
          if (!el) return;
          localStorage.setItem(key, "1");
          el.scrollTo({ top: el.scrollHeight, behavior: smooth ? "smooth" : "auto" });
        }

  const [isLoading, setIsLoading] = useState(true);
  const [caseStudy, setCaseStudy] = useState(null);
  const navigate = useNavigate();
  const { caseId } = useParams();
  const [searchParams] = useSearchParams();

  // Resolve phase from query (?phase=submissionTwo) or default to 1
  const phaseParam = searchParams.get("phase");
  const PHASE = ALLOWED_PHASES.includes(phaseParam) ? phaseParam : "submissionOne";

  const caseIdx = user?.completedCases?.responses?.findIndex((r) => r.caseId === caseId);

  const [questionsUsed, setQuestionsUsed] = useState(
    user?.completedCases?.responses[caseIdx]?.logOpenAI
      ? user?.completedCases?.responses[caseIdx]?.logOpenAI?.length
      : window.localStorage.getItem(`case-${caseId}-questionsUsed`) || 0
  );

  const [interactions, setInteractions] = useState(
    user?.completedCases?.responses[caseIdx]?.logOpenAI?.length
      ? user?.completedCases?.responses[caseIdx]?.logOpenAI
      : JSON.parse(window.localStorage.getItem(`case-${caseId}-interactions`)) || []
  );

  const [priorResponses, setPriorResponses] = useState(
    JSON.parse(window.localStorage.getItem(`case-${caseId}-priorResponses`)) || []
  );

  const [score, setScore] = useState(
    user?.completedCases?.responses[caseIdx]
      ? user?.completedCases?.responses[caseIdx]?.score
      : JSON.parse(window.localStorage.getItem(`case-${caseId}-score`)) || 1000
  );

  const [scoreMessage, setScoreMessage] = useState("");
  const [submitted, setSubmitted] = useState(
    JSON.parse(window.localStorage.getItem(`case-${caseId}-${PHASE}-submitted`)) || false
  );

  // Rationale (persist per case/phase)
  const [rationale, setRationale] = useState(
    window.localStorage.getItem(`case-${caseId}-${PHASE}-rationale`) || ""
  );
  useEffect(() => {
    window.localStorage.setItem(`case-${caseId}-${PHASE}-rationale`, rationale || "");
  }, [rationale, caseId, PHASE]);



  // Ranking state
  const [rankings, setRankings] = useState([]);
  const dragStartIndex = useRef(null);

  // Survey state (after submitting phase 6)
  const [showSurvey, setShowSurvey] = useState(false);
  const [survey, setSurvey] = useState(() => {
    const saved = JSON.parse(window.localStorage.getItem(`case-${caseId}-survey`)) || {};
    return {
      ratingOne: saved.ratingOne || "",
      ratingTwo: saved.ratingTwo || "",
      reflection: saved.reflection || "",
    };
  });
  const [surveySubmitted, setSurveySubmitted] = useState(
    JSON.parse(window.localStorage.getItem(`case-${caseId}-survey-submitted`)) || false
  );



    // as of 10.3.25, adding functions below to clear case data without clearing all local storage (to stay logged in)

          const didResetRef = useRef(false);

          useEffect(() => {
            if (!caseId) return;
            if (didResetRef.current) return; // guard (React Strict Mode runs effects twice in dev)
          
            // 1) Delete ONLY the keys for this case (keeps auth token intact)
            const prefix = `case-${caseId}-`;
            const toDelete = [];
            for (let i = 0; i < window.localStorage.length; i++) {
              const k = window.localStorage.key(i);
              if (k && k.startsWith(prefix)) toDelete.push(k);
            }
            toDelete.forEach(k => window.localStorage.removeItem(k));
          
            // 2) Reset in-memory state to clean defaults
            setQuestionsUsed(0);
            setInteractions([]);
            setPriorResponses([]);
            setScore(1000);
            setScoreMessage("");
            setSubmitted(false);
            setRationale("");
            setRankings([]); // will be rehydrated from caseStudy.multipleChoices when it loads
            setShowSurvey(false);
            setSurvey({ ratingOne: "", ratingTwo: "", reflection: "" });
            setSurveySubmitted(false);
          
            didResetRef.current = true;
          }, [caseId]);

          // 10.3.25 reset of case data (except user logged in) as above



  // Load case
  async function handleRequest() {
    try {
      const response = await getCase(caseId);
      if (response._id) {
        setCaseStudy(response);
        setIsLoading(false);
      } else {
        navigate("/");
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    handleRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Initialize / hydrate rankings when caseStudy loads or PHASE changes
  useEffect(() => {
    if (!caseStudy?.multipleChoices) return;

    // 1) Try this phase's saved ranking (if exists and matches length)
    const thisKey = `case-${caseId}-${PHASE}-rankings`;
    const savedForThisPhase = JSON.parse(window.localStorage.getItem(thisKey));
    const sameLength = (arr) =>
      Array.isArray(arr) && arr.length === caseStudy.multipleChoices.length;

    if (sameLength(savedForThisPhase)) {
      setRankings(savedForThisPhase);
    } else {
      // 2) Otherwise, carry forward the most recent prior phase's ranking
      const currIdx = ALLOWED_PHASES.indexOf(PHASE);
      let carried = null;

      for (let i = currIdx - 1; i >= 0; i--) {
        const prevPhase = ALLOWED_PHASES[i];
        const prevKey = `case-${caseId}-${prevPhase}-rankings`;
        const prevSaved = JSON.parse(window.localStorage.getItem(prevKey));
        if (sameLength(prevSaved)) {
          carried = prevSaved;
          break;
        }
      }

      setRankings(carried || caseStudy.multipleChoices);
    }

    // refresh per-phase submitted + rationale
    const phaseSubmitted =
      JSON.parse(window.localStorage.getItem(`case-${caseId}-${PHASE}-submitted`)) || false;
    setSubmitted(phaseSubmitted);
    setRationale(window.localStorage.getItem(`case-${caseId}-${PHASE}-rationale`) || "");

    // show survey if and only if we are on phase 6 and it is submitted
    setShowSurvey(PHASE === "submissionSix" && phaseSubmitted);
  }, [caseStudy, caseId, PHASE]);

  // Persist rankings
  useEffect(() => {
    if (rankings?.length) {
      window.localStorage.setItem(`case-${caseId}-${PHASE}-rankings`, JSON.stringify(rankings));
    }
  }, [rankings, caseId, PHASE]);

  // Drag & Drop
  function handleDragStart(e, index) {
    dragStartIndex.current = index;
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", String(index));
  }

  function handleDragOver(e) {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  }

  function handleDrop(e, dropIndex) {
    e.preventDefault();
    const startIndexStr = e.dataTransfer.getData("text/plain");
    const startIndex = startIndexStr ? parseInt(startIndexStr, 10) : dragStartIndex.current;
    if (startIndex === null || startIndex === undefined) return;
    if (startIndex === dropIndex) return;

    setRankings((prev) => {
      const arr = [...prev];
      const [moved] = arr.splice(startIndex, 1);
      arr.splice(dropIndex, 0, moved);
      return arr;
    });
    dragStartIndex.current = null;
  }

  // Up / Down Controls
  function moveItem(index, direction) {
    setRankings((prev) => {
      const arr = [...prev];
      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= arr.length) return arr;
      const [item] = arr.splice(index, 1);
      arr.splice(newIndex, 0, item);
      return arr;
    });
  }

  // Submit Ranked List (includes PHASE, rationale, interactions)
  async function handleSubmitRankings() {
    try {
      const rankedPayload = rankings.map((label, idx) => ({ label, rank: idx + 1 }));

      window.localStorage.setItem(`case-${caseId}-${PHASE}-rankings`, JSON.stringify(rankings));
      window.localStorage.setItem(`case-${caseId}-${PHASE}-submitted`, JSON.stringify(true));
      setSubmitted(true);

      const response = await sendResponse(caseId, {
        phase: PHASE,
        rankings: rankedPayload,
        questionsUsed,
        interactions,
        rationale,
        score,
        priorResponses,
      });

      if (response?.caseStudy) setCaseStudy(response.caseStudy);
      if (user && response?.token) {
        window.localStorage.setItem(`token`, response.token);
        setUser(await getUser());
      }

      const next = NEXT_PHASE[PHASE];
      if (next) {
        setScoreMessage(
          <h4 key={Math.random()} className="fading-text">
            <span className="grey-text">
              {`Submission ${ALLOWED_PHASES.indexOf(PHASE) + 1} saved. Moving to Submission ${
                ALLOWED_PHASES.indexOf(next) + 1
              }…`}
            </span>
          </h4>
        );
        navigate(`/cases/${caseId}?phase=${next}`);
        return;
      }

      // After phase 6: show survey (hide chat & rationale, keep rankings visible as submitted)
      setShowSurvey(true);
      setScoreMessage(
        <h4 key={Math.random()} className="fading-text">
          <span className="grey-text">Final submission saved. Please complete the survey.</span>
        </h4>
      );
    } catch (err) {
      console.log(err);
      setScoreMessage(
        <h4 key={Math.random()} className="fading-text">
          <span className="red-text">Error submitting ranking. Please try again.</span>
        </h4>
      );
    }
    // eslint-disable-next-line no-console
    // console.log("here is the response item:", caseStudy, "and interactions:", interactions);
  }

  // Reset Ranking to Original Order (per-phase)
  function resetRanking() {
    if (!caseStudy?.multipleChoices) return;
    setRankings(caseStudy.multipleChoices);
    window.localStorage.setItem(
      `case-${caseId}-${PHASE}-rankings`,
      JSON.stringify(caseStudy.multipleChoices)
    );
    setSubmitted(false);
    window.localStorage.setItem(`case-${caseId}-${PHASE}-submitted`, JSON.stringify(false));
    setScoreMessage("");
    // keep rationale as-is; uncomment to clear
    // setRationale(""); localStorage.setItem(`case-${caseId}-${PHASE}-rationale`, "");
  }

  // Survey handlers (now posts to backend)
  function handleSurveyChange(e) {
    const { name, value } = e.target;
    setSurvey((prev) => {
      const next = { ...prev, [name]: value };
      window.localStorage.setItem(`case-${caseId}-survey`, JSON.stringify(next));
      return next;
    });
  }

  async function handleSurveySubmit() {
    try {
      const payload = {
        ratingOne: Number(survey.ratingOne),
        ratingTwo: Number(survey.ratingTwo),
        reflection: survey.reflection || "",
      };

      if (!payload.ratingOne || !payload.ratingTwo) {
        setScoreMessage(
          <h4 key={Math.random()} className="fading-text">
            <span className="red-text">Please select both ratings (1–5) before submitting.</span>
          </h4>
        );
        return;
      }

      const resp = await sendSurvey(caseId, payload);

      // if (user && resp?.token) {
      //   window.localStorage.setItem("token", resp.token);
      //   setUser(await getUser());
      // }

         // ★ NEW: 10.5.25 - record the completed caseId (schema unchanged); above code commented out, below added

         if (user && resp?.token) {
          window.localStorage.setItem("token", resp.token);
         }
          
         // Record completion and set the fresh user from the server response
          const updatedUser = await addCompletedCaseId(caseId);
            setUser(updatedUser);

              // await addCompletedCaseId(caseId);
            // single line above added

      window.localStorage.setItem(`case-${caseId}-survey`, JSON.stringify(payload));
      window.localStorage.setItem(`case-${caseId}-survey-submitted`, JSON.stringify(true));
      setSurveySubmitted(true);

      setScoreMessage(
        <h4 key={Math.random()} className="fading-text">
          <span className="grey-text">Survey submitted. Thanks!</span>
        </h4>
      );

      // 10.12.25, commenting out the hard reload! but then changed it back
      // window.location.reload();
      navigate("/user");   

    } catch (err) {
      console.log(err);
      setScoreMessage(
        <h4 key={Math.random()} className="fading-text">
          <span className="red-text">Error submitting survey. Please try again.</span>
        </h4>
      );
    }
  }

  // Nice label like "Submission 1", "Submission 2"
  const phaseNumber = ALLOWED_PHASES.indexOf(PHASE) + 1;

  // Chat enabled by phase, but force-hide when survey is showing
  const chatEnabled = CHAT_ENABLED.has(PHASE) && !showSurvey;

// adding this late evening 10.1.25:

  // Which content to show on the left by phase:
  const phaseIdx = ALLOWED_PHASES.indexOf(PHASE); // 0..5
  const showInitial = phaseIdx >= 0;  // phases 1–6
  const showDescription = phaseIdx >= 2; // phases 3–6
  const showImage = phaseIdx >= 4; // phases 5–6


  // BELOW WILL LATER BE DELETED... this is just for pilot initial case run 10.2025

    const labRows = [
      { section: "Blood" },
      { name: "Sodium", value: "140 mEq/L", range: "136-145" },
      { name: "Potassium", value: "3.7 mEq/L", range: "3.5-5.0" },
      { name: "Chloride", value: "98 mEq/L", range: "98-106" },
      { name: "Total CO2", value: "22 mEq/L", range: "23-28" },
      { name: "Glucose", value: "121 mg/dL", range: "70-99 fasting" },
      { name: "BUN", value: "75 mg/dL", range: "8-20" },
      { name: "Creatinine", value: "2.6 mg/dL", range: "0.5-1.1" },
      { name: "> baseline creatinine 3 months ago", value: "1.0 mg/dL", range: "0.5-1.1" },
      { name: "Calcium", value: "9.5 mg/dL", range: "8.6-10.2" },
      { name: "Albumin", value: "3.8 g/dL", range: "3.5-5.5" },
      { name: "WBC Count", value: "9.2K/uL", range: "4K-11K" },
      { name: "> abs. eosinophils", value: "430/uL", range: "<500" },
      { name: "Hemoglobin", value: "13.5 g/dL", range: "13-17" },
      { name: "Platelets", value: "320K/uL", range: "150K-450K" },
      { section: "Urine" },
      { name: "Protein-to-creatinine ratio (spot)", value: "0.4 g/g", range: "<0.2" },
      { name: "Albumin-to-creatinine ratio (spot)", value: "188 mg/g", range: "<30" },
      { name: "Sodium", value: "20 mEq/L", range: "variable" },
      { name: "Creatinine", value: "42 mg/dL", range: "variable" },
    ];

    const labRows2 = [
      { section: "Blood" },
      { name: "Sodium", value: "139 mEq/L", range: "136-145" },
      { name: "Potassium", value: "4.6 mEq/L", range: "3.5-5.0" },
      { name: "Chloride", value: "106 mEq/L", range: "98-106" },
      { name: "Total CO2", value: "18 mEq/L", range: "23-28" },
      { name: "BUN", value: "65 mg/dL", range: "8-20" },
      { name: "Creatinine", value: "2.8 mg/dL", range: "0.5-1.1" },
      { name: "Albumin", value: "3.2 g/dL", range: "3.5-5.5" },
      { section: "Urine" },
      { name: "Sodium", value: "120 mEq/L", range: "variable" },
      { name: "Creatinine", value: "60 mg/dL", range: "variable" },
    ];




  return isLoading ? (
    <Loader />
  ) : (

    // <section className="cases-show-page-ctr">
    // late night 10.1.25, alterantive below to use CSS to toggle off everything except survey at that point
  <section className={`cases-show-page-ctr ${showSurvey ? "survey-only" : ""}`}>

      {/* <h3 className="title">{caseStudy?.title}</h3> */}

      {/* <hr className="lightgrey" /> */}
      <div className="case-show-grid">
        
        {/* <div>
          <img src={caseStudy?.image} alt="case study" />
        </div> */}

          {/* late evening 10.1, commenting out above and replacing with the below so we get 1) initial sx 2) description 3) image */}

                    <div className="case-left">

            <h3 className="title">{caseStudy?.title}</h3>

            {showInitial && caseStudy?.initialSymptoms && (
              <div className="initial-symptoms">
                <h4 className="case-left-format">Part 1</h4>
                <p className="case-left-format" >A 65-year-old man presents to the emergency department with acute kidney injury. For the past three days, the patient has experienced general malaise with intermittent lightheadedness and nausea. He has had reduced intake and vomited once yesterday, but he denies any diarrhea, abdominal pain, or dyspnea. Although the patient has no flank pain or frank burning with urination, he has difficulty initiating his urinary stream. His past medical history includes hypertension, type 2 diabetes mellitus, atrial fibrillation, benign prostatic hyperplasia, and a history of renal cell carcinoma, for which he underwent a right radial nephrectomy 18 years ago. His home medications include metoprolol succinate 25 mg daily, amlodipine 10 mg daily, metformin 1000 mg twice daily, and finasteride 5 mg daily. Last year, he went to his primary care physician with several days of back pain that he thought may have been a kidney stone, but this was never confirmed on imaging, and he has never had prior known episodes of nephrolithiasis. Four months ago, he was admitted to the hospital for five days with pneumonia. More recently, he was treated at an urgent care facility ten days ago for a “toe and foot infection” with oral cephalexin, which he is still taking for a two-week course. He denies any other recent medication changes, and he does not take NSAIDs. Vital signs show a temperature of 98 deg. F, a blood pressure of 132/76 mm Hg, and pulse of 84 /min. Physical exam is notable for clear lungs, a JVP of 6 cm, an irregularly irregular heart rhythm, no abdominal or CVA tenderness, trace lower extremity edema, and no skin findings aside from a shallow ulcer on the right great toe that appears clean and nearly healed without any  surrounding erythema. Initial chemistries in the emergency department reveal the following:</p>

              {/* for pilot run 10.2025, will just add the first case data here, since there will not be an admin account making cases */}


              <div className="labtable-wrap">
                    <table className="labtable">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Value</th>
                          <th>Ref. Range</th>
                        </tr>
                      </thead>
                      <tbody>
                        {labRows.map((r, i) =>
                          r.section ? (
                            <tr key={`sec-${i}`} className="section-row">
                              <td className="section-label"><strong>{r.section}</strong></td>
                              <td aria-hidden="true">&nbsp;</td>
                              <td aria-hidden="true">&nbsp;</td>
                            </tr>
                          ) : (
                            <tr key={`row-${i}`}>
                              <td>{r.name}</td>
                              <td>{r.value}</td>
                              <td>{r.range}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>

                  <p className="case-left-format">Urine dipstick reveals trace leukocytes, 1+ protein, and negative for heme</p>
          </div>

            )}

            {showDescription && caseStudy?.description && (
              <div className="case-description" style={{ marginTop: 12 }}
              
              ref={(el) => {
                if (!el || !showDescription) return;
                setTimeout(() => {
                  scrollCaseLeftOncePerPhase({ caseId, phase: PHASE, tag: "desc", smooth: true });
                }, 0);
              }}
            >

<br></br>
      <h4 className="case-left-format">Part 2</h4>

                {/* <p>{caseStudy.description}</p> */}

                

                <p className="case-left-format">A retroperitoneal ultrasound shows a 10.5 cm left kidney without any evidence of hydronephrosis or stones and an absence of a right kidney</p>


                <p className="case-left-format">The patient receives 2L of 0.9% Normal Saline. Repeat Chemistries 12 hours later demonstrate the following:</p>


              <div className="labtable-wrap">
                    <table className="labtable">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Value</th>
                          <th>Ref. Range</th>
                        </tr>
                      </thead>
                      <tbody>
                        {labRows2.map((r, i) =>
                          r.section ? (
                            <tr key={`sec-${i}`} className="section-row">
                              <td className="section-label"><strong>{r.section}</strong></td>
                              <td aria-hidden="true">&nbsp;</td>
                              <td aria-hidden="true">&nbsp;</td>
                            </tr>
                          ) : (
                            <tr key={`row-${i}`}>
                              <td>{r.name}</td>
                              <td>{r.value}</td>
                              <td>{r.range}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>

              </div>
            )}


            {showImage && caseStudy?.image && (
              <div className="case-image" style={{ marginTop: 12 }}>
 
 <br></br>
                 <h4 className="case-left-format">Part 3</h4>
                
{/*                 
                <img src={caseStudy.image} alt="case study" 
                
                onLoad={() => {
                  requestAnimationFrame(() =>
                    scrollCaseLeftOncePerPhase({ caseId, phase: PHASE, tag: "image", smooth: true })
                  );
                }}
              /> */}


<p className="case-left-format">Urine sediment microscopy reveals 30 white blood cells /hpf, and a white blood cell cast is identified.</p>
<p className="case-left-format">Urine culture is sent and returns negative 48 hours later</p>

            </div>

            )}


            

          </div>




        <div className="about-case">
          {/* Chat toggles by phase; overlay when locked */}
          <div className="chat-shell" style={{ position: "relative" }}>
            {chatEnabled ? (
              <OpenAI
                caseStudy={caseStudy}
                questionsUsed={questionsUsed}
                setQuestionsUsed={setQuestionsUsed}
                interactions={interactions}
                setInteractions={setInteractions}
                user={user}
                score={score}
                setScore={setScore}
                scoreMessage={scoreMessage}
                setScoreMessage={setScoreMessage}
                correct={false}
              />
            ) : (
              <>
                <OpenAI
                  caseStudy={caseStudy}
                  questionsUsed={questionsUsed}
                  setQuestionsUsed={setQuestionsUsed}
                  interactions={interactions}
                  setInteractions={setInteractions}
                  user={user}
                  score={score}
                  setScore={setScore}
                  scoreMessage={scoreMessage}
                  setScoreMessage={setScoreMessage}
                  correct={false}
                  disabled
                  aria-disabled="true"
                />
                <div className="chat-disabled notice chat-overlay">
                  {/* <p>
                    <strong>AI chat is locked</strong>
                    {showSurvey
                      ? " while you complete the survey."
                      : " for this submission. Rank your diagnoses and provide a brief rationale. AI chat will unlock in the next submission."}
                  </p> */}
                  <p>AI chat is locked</p>
                </div>
              </>
            )}
          </div>

          <hr className="lightgrey" />

          <div className="unanswered">

            {/* <div className="phase-banner">
              <strong>Phase:</strong> {`Submission ${phaseNumber}`}
            </div> */}

            <h4 className="rank-instructions justify-left">Rank DDx from most likely (1) to least likely (5):</h4>

            {/* Rankings are always visible; after submit they are frozen (draggable={!submitted}) */}
            <ol className="choices-ctr ranking-list" aria-label="Rank choices">
              {rankings?.map((item, idx) => (
                <RankRow key={item} item={item} index={idx} />
              ))}
            </ol>

            {/* Hide rationale and ranking actions when survey is showing (post phase-6) */}
            {!showSurvey && (
              <>
                {/* Rationale input */}


                      <div className="rationale-block" style={{ marginTop: 16 }}>

 
                      <label htmlFor="rationale" className="justify-left">
                    <strong>
                      Brief rationale {chatEnabled ? "" : " "}{" "}
                    </strong>
                  </label>
                  
                        <textarea
                          id="rationale"
                          value={rationale}
                          onChange={(e) => setRationale(e.target.value)}
                          placeholder="Why did you rank them this way?"
                          rows={3}
                          className="rationale-textarea"
                          style={{ width: "100%", marginTop: 8 }}
                        />

                      </div>

                <div className="ranking-actions" style={{ marginTop: 2 }}>


                <label htmlFor="rationale" className="submit-instructions">
                          <br></br>
                          <strong>
                            INSTRUCTIONS&nbsp;-&nbsp;      </strong>
                            {PHASE === "submissionOne"
                              ? "Rank DDx and provide a brief rationale"
                              : PHASE === "submissionTwo" || PHASE === "submissionFour"
                              ? "Now try using ChatGPT. Update your DDX ranking and brief rationale as needed"
                              : PHASE === "submissionSix"
                              ? "Now try using ChatGPT. Submit your final updated DDX ranking and brief rationale"
                              : "Based on new case data, update your DDx ranking and brief rationale as needed"}
                    
                        </label>


                  <button
                    type="button"
                    className={`primary-btn ${submitted ? "disabled" : ""}`}
                    onClick={handleSubmitRankings}
                    disabled={submitted /* || !rationale.trim() */}
                  >
                    {submitted ? (
                      <>
                        <MdCheck style={{ marginRight: 6 }} />
                        
                      </>
                    ) : (
                      PHASE === "submissionOne"
                        ? "Submit"
                        : PHASE === "submissionTwo" || PHASE === "submissionFour"
                        ? "Resubmit"
                        : PHASE === "submissionSix"
                        ? "Resubmit"
                        : "Submit"
                    )}
                  </button>

                  {/* <button type="button" className="secondary-btn" onClick={resetRanking}>
                    Reset Order
                  </button> */}
                </div>
              </>
            )}

            {/* Survey shows only after submitting Phase 6, while rankings remain visible above */}
            {showSurvey && (
              <div className="survey-block" style={{ marginTop: 24 }}>
                <div className="phase-banner">
                  <strong>Survey</strong>
                </div>

                <h3>Brief Reflections</h3>
                <br></br>
                <div className="survey-question" style={{ marginBottom: 12 }}>
                  <label>
                    <strong>How informative was the pre-work lecture? </strong>
                  </label>
                  <p><small>"Artificial Intelligence in Medicine:
                    a Pre-Clerkship Primer"</small></p>
                    <p><small>1 = not informative  |  5 = extremely informative</small></p>
                  <div className="radio-group">
                    {[1, 2, 3, 4, 5].map((n) => (
                      <label key={`r1-${n}`} style={{ marginRight: 12 }}>
                        <input
                          type="radio"
                          name="ratingOne"
                          value={String(n)}
                          checked={String(survey.ratingOne) === String(n)}
                          onChange={handleSurveyChange}
                        />{" "}
                        {n}
                      </label>
                    ))}
                  </div>
                </div>

                <div className="survey-question" style={{ marginBottom: 12 }}>
                <br></br>
                  <label>
                    <strong>How much did the AI chat influence your DDx rankings?</strong>
                  </label>
                  <p><small>1 = least  |  5 = most</small></p>
                  <div className="radio-group">
                    {[1, 2, 3, 4, 5].map((n) => (
                      <label key={`r2-${n}`} style={{ marginRight: 12 }}>
                        <input
                          type="radio"
                          name="ratingTwo"
                          value={String(n)}
                          checked={String(survey.ratingTwo) === String(n)}
                          onChange={handleSurveyChange}
                        />{" "}
                        {n}
                      </label>
                    ))}
                  </div>
                </div>

                <div className="survey-question" style={{ marginBottom: 12 }}>
                  <label htmlFor="reflection">
                  <br></br>
                  <br></br>
                    <strong>Please reflect on the use of AI in this case:</strong>

                  </label>
                  <textarea
                    id="reflection"
                    name="reflection"
                    value={survey.reflection}
                    onChange={handleSurveyChange}
                    placeholder="Share your reflections here."
                    rows={4}
                    style={{ width: "100%", marginTop: 8 }}
                  />

<br></br>
                </div>


                <div className="ranking-actions" style={{ marginTop: 16 }}>
                 
                  <button
                    type="button"
                    className={`primary-btn ${surveySubmitted ? "disabled" : ""}`}
                    onClick={handleSurveySubmit}
                    disabled={surveySubmitted}
                  >
                    {surveySubmitted ? (
                      <>
                        <MdCheck style={{ marginRight: 6 }} />
                        Survey Submitted
                      </>
                    ) : (
                      "Submit Survey"
                    )}
                  </button>
  
                </div>
                <p><small>(must answer all to submit)</small></p>
              </div>
            )}


            {/* <hr />
            <div className="score">
              <h3>Your current score: {score}</h3>
            </div>
            <div>{scoreMessage}</div> */}
          </div>
        </div>
      </div>
    </section>
  );

  // UI helpers
  function RankRow({ item, index }) {
    const isTop = index === 0;
    const isBottom = index === rankings.length - 1;
  
    return (
      <li
        className="mc-li rankable"
        draggable={!submitted}
        onDragStart={(e) => handleDragStart(e, index)}
        onDragOver={handleDragOver}
        onDrop={(e) => handleDrop(e, index)}
        role="option"
        aria-grabbed="false"
      >
        <div className="rank-row">
          <div className="rank-left compact">
            {/* Drag handle (optional) */}
            <MdDragIndicator className="drag-handle" aria-hidden />
  
            {/* Up/Down on the left */}
            <button
              type="button"
              className="rank-btn"
              onClick={() => moveItem(index, -1)}
              disabled={submitted || isTop}
              aria-label={`Move ${item} up`}
              title="Move up"
            >
              <MdArrowUpward />
            </button>
            <button
              type="button"
              className="rank-btn"
              onClick={() => moveItem(index, +1)}
              disabled={submitted || isBottom}
              aria-label={`Move ${item} down`}
              title="Move down"
            >
              <MdArrowDownward />
            </button>
  
            {/* Label */}
            <span className="rank-label">{item}</span>
          </div>
        </div>
      </li>
    );
  }
}
